module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row pad header-fixed site-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col s1m yo-align-right"
  }, [(_vm.$teras.language == 'it') ? _c('img', {
    attrs: {
      "src": require("../assets/ico-eng.png")
    },
    on: {
      "click": function($event) {
        return _vm.changeLang('en')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$teras.language == 'en') ? _c('img', {
    attrs: {
      "src": require("../assets/ico-ita.png")
    },
    on: {
      "click": function($event) {
        return _vm.changeLang('it')
      }
    }
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s9m offset-sm"
  }, [_vm._v("BIOMEDIA "), _c('span', {
    staticStyle: {
      "font-size": "80%"
    }
  }, [_vm._v("PIATTAFORMA ABSTRACT")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17f8f893"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Site-header.vue
// module id = 601
// module chunks = 2